import { Stack } from '@mui/material'

import { EditTimeWindow } from './components/EditTimeWindow'

import { useActions } from './hooks/useActions'

interface Props {
  onUpdateTimeWindow: (timeWindow: uui.domain.rm.TimeWindow, timeWindowIndex: 0 | 1) => void
  onRemoveTimeWindow: (timeWindowIndex: 0 | 1) => void
  validate: (force?: boolean) => void
  value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]
  disabled?: boolean
}

export function EditTimeWindows(props: Props) {
  const { value, onRemoveTimeWindow, validate, disabled, onUpdateTimeWindow } = props
  const [tw1, tw2] = value

  const actions = useActions(onUpdateTimeWindow, onRemoveTimeWindow)

  return (
    <Stack spacing={2}>
      {!!tw1 && (
        <EditTimeWindow
          value={tw1}
          onRemoveTimeWindow={actions.onRemoveTimeWindow1}
          onUpdateTimeWindow={actions.onUpdateTimeWindow1}
          validate={validate}
          disabled={disabled}
        />
      )}
      {!!tw2 && (
        <EditTimeWindow
          value={tw2}
          onRemoveTimeWindow={actions.onRemoveTimeWindow2}
          onUpdateTimeWindow={actions.onUpdateTimeWindow2}
          validate={validate}
          disabled={disabled}
        />
      )}
    </Stack>
  )
}
